import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-abc-registration',
  templateUrl: './abc-registration.component.html',
  styleUrls: ['./abc-registration.component.scss']
})
export class AbcRegistrationComponent implements OnInit {

  GenderList = [
    { value: 'Male', label: 'Male' },
    { value: 'Female', label: 'Female' }
  ];
   abcForm: FormGroup;
   submitpayload: any;
   dialogRef: MatDialogRef<any>;
   accessToken: any;
  constructor(
      private fb: FormBuilder,
      private spinner: NgxSpinnerService,
      public umsService: UmsService,
      private modalPopupService: ModalpopService,
      public router: Router
  ) { }

  ngOnInit(): void {

    this.abcForm = this.fb.group({
      aadhaarName: new FormControl('', [Validators.required,]),
      aadhaarDOB: new FormControl('', [Validators.required, Validators.maxLength(10)]),
      aadhaarGender: new FormControl('', [Validators.required]),
      aadhaarNumber: new FormControl('', [Validators.required, Validators.maxLength(12),Validators.pattern('^[0-9]*$')]),
      aadhaarMobile: new FormControl('', [Validators.required, Validators.maxLength(10),Validators.pattern('^[0-9]*$')]),
    });
    
    //this.getAccessToken();
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  getAccessToken() { 
    this.submitpayload = {}
    this.umsService.getABCAccessToken(this.submitpayload).subscribe((res) => {
      this.accessToken = res.data.access_token;
      this.submitAaadhaarDetails();
    }, (ERROR: HttpErrorResponse) => {
    //  alert(ERROR.error.message);
        }
  )
  }

  submit() {
    if(this.abcForm.invalid) {
      this.abcForm.get('aadhaarName').markAsTouched();
      this.abcForm.get('aadhaarDOB').markAsTouched();
      this.abcForm.get('aadhaarGender').markAsTouched();
      this.abcForm.get('aadhaarNumber').markAsTouched();
      this.abcForm.get('aadhaarMobile').markAsTouched();
   }
   else{
      this.getAccessToken();
    //  this.submitAaadhaarDetails()
   }
  }



  submitAaadhaarDetails() {
    this.spinner.show();
    this.submitpayload = {}
    const genderValue = this.abcForm.controls['aadhaarGender'].value;
    const genderInitial = genderValue.substring(0, 1);
    //this.submitpayload = this.abcForm.value;
   // this.submitpayload['accessToken'] = this.accessToken;
    this.submitpayload['aadhaarName'] =   this.abcForm.controls['aadhaarName'].value;
    this.submitpayload['aadhaarNumber'] = this.abcForm.controls['aadhaarNumber'].value;
    this.submitpayload['dob'] = this.abcForm.controls['aadhaarDOB'].value;
    this.submitpayload['gender'] = genderInitial;
    this.submitpayload['mobile'] = this.abcForm.controls['aadhaarMobile'].value;
    //return
    this.umsService.createABCID(this.submitpayload).subscribe((res) => {
      alert("Message: " + res.data.message + "\n" + "ABC ID: " + res.data.ABC_ACCOUNT_ID);
      this.spinner.hide();
      this.redirect('deb-registration');
      // let data = {}
      //     data['message'] = res.data.message;
      //     data['title'] = 'Information'
      //     data['icon'] = 'fas fa-check'
      //     this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      //  this.dialogRef.afterClosed().subscribe(result => {
      //  });
  
  
    }, (ERROR: HttpErrorResponse) => {
    //  alert(ERROR.error.message);
     this.spinner.hide();
        }
  )
  }

}
